import { BootstrapUtil } from './shared-inline';
(function () {
    try {
        if ('serviceWorker' in window.navigator) {
            window.diskPreloadUserIdStorageKey = 'OfficeHomeDiskPreloadUserStorageId';
            window.diskPreloadUrlStorageKey = 'OfficeHomeDiskPreloadUrlStorageKey';
            window.diskPreloadRequestMap = new Map();
            var userId = JSON.parse(localStorage.getItem(window.diskPreloadUserIdStorageKey));
            BootstrapUtil.InitDiskPreload(userId, window.diskPreloadRequestMap, window.diskPreloadUrlStorageKey);
        }
    }
    catch (ex) { /* Do nothing. */ }
})();
